<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_ba91"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button @click="showAddCollectionModel">
          添加代收协议
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      show-footer
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="licenseNumber" title="车牌号" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车队名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="isMasterText" title="是否主驾" sortable>
          <template v-slot:default="{ row }">
            <span
              :style="{
                color: row.isMaster === 1 ? '#67C23A' : '#909399'
              }"
            >
              {{ row.isMaster === 1 ? "是" : "否" }}
            </span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMaster"
            clearable
            placeholder="请选择"
          >
            <el-option :key="0" label="否" :value="0" />
            <el-option :key="1" label="是" :value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="authStatusText" title="审核状态" sortable />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            clearable
            placeholder="请选择审核状态"
          >
            <el-option :key="0" label="未审核" :value="0" />
            <el-option :key="1" label="审核中" :value="1" />
            <el-option :key="2" label="审核未通过" :value="2" />
            <el-option :key="3" label="审核通过" :value="3" />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="vehicleNatureText" title="车辆性质" sortable />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleNature"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in vehicleTypeOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="agreementStatusText" title="协议" sortable>
          <template v-slot:default="{ row }">
            <span
              :style="{
                color: row.agreementStatus === 1 ? '#67C23A' : '#909399'
              }"
            >
              {{ row.agreementStatusText }}
            </span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.agreementStatus"
            clearable
            placeholder="请选择"
          >
            <el-option :key="0" label="未上传" :value="0" />
            <el-option :key="1" label="已上传" :value="1" />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- 是否确认 -->
      <vxe-table-column>
        <vxe-table-column field="isConfirmed" title="是否确认" sortable>
          <template v-slot:default="{ row }">
            <span
              :style="{
                color: row.isConfirmed === 1 ? '#67C23A' : '#909399'
              }"
            >
              {{ row.isConfirmed === 1 ? "是" : "否" }}
            </span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select
            v-model="listQuery.isConfirmed"
            clearable
            placeholder="请选择"
          >
            <el-option :key="0" label="否" :value="0" />
            <el-option :key="1" label="是" :value="1" />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
      <vxe-table-column>
        <template v-slot:header>
          <el-select v-model="listQuery.collection" clearable placeholder="请选择">
            <el-option :key="0" label="待授权" :value="0"/>
            <el-option :key="1" label="已同意" :value="1"/>
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看协议"
            placement="top"
          >
            <vxe-button
              type="text"
              style="color: #1890ff;cursor: pointer;"
              @click="showCollectionAgreementModel(scope.row)"
            >
              查看协议
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="scope.row.collection==1"
            class="item"
            effect="dark"
            content="查看协议"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="showCollectionAgreementModel(scope.row.acceptCode)"
            >
              <i class="el-icon-view" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="协议记录"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="showCollectionAgreementLogListModel(scope.row.acceptCode)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="isOneDriver"
            class="item"
            effect="dark"
            content="退出车队"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="outTeam(scope.row.partyCode)"
            >
              <i class="el-icon-remove" />
            </vxe-button>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- <vxe-modal
      v-model="collectionAgreementFlag"
      title="代收协议"
      width="800"
      height="800"
    >
      <collectionAgreement
        ref="collectionAgreementRef"
        action-path="old"
        @hideModel="hideCollectionAgreementModel"
      />
    </vxe-modal> -->
    <vxe-modal
      v-model="collectionAgreementFlag"
      title="查看协议"
      width="800"
      height="500"
    >
      <!-- 车辆性质 -->
      <el-form v-if="collectionAgreementFlag" class="vehicle-agreement-form">
        <div class="form-section">
          <h3>车辆性质</h3>
          <el-radio-group v-model="vehicleNature">
            <el-radio
              v-for="item in vehicleTypeOptions"
              :key="item.value"
              :label="item.code"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="form-section">
          <h3>上传协议</h3>
          <multipleUpload
            :required="false"
            :max-count="10"
            :disabled="false"
            :img-list.sync="imgList"
            @totalSuccess="totalSuccess"
          />
        </div>
      </el-form>
      <div class="modal-footer">
        <el-button type="primary" @click="uploadVehicleAgreementApi"
          >确定</el-button
        >
      </div>
      <!--  -->
    </vxe-modal>
    <vxe-modal
      v-model="collectionAgreementLogListFlag"
      title="代收协议记录"
      width="800"
      height="800"
    >
      <collectionAgreementLogList
        ref="collectionAgreementLogListRef"
        @hideModel="hideCollectionAgreementLogListModel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="addCollectionFlag"
      title="添加代收协议"
      width="400"
      height="400"
    >
      <addCollectionAgreement
        ref="addCollectionAgreementRef"
        @hideModel="hideAddCollectionModel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import multipleUpload from "@/components/ImgUpload/multipleUpload.vue";
import { VehicleType, uploadVehicleAgreement } from "@/api/orderform";
import request from "@/utils/request";
import addCollectionAgreement from "./collectionAgreementLogAdd.vue";
import collectionAgreementLogList from "./collectionAgreementLogList.vue";
import collectionAgreement from "./collectionAgreement.vue";
export default {
  name: "MyVehicleTeam",
  components: {
    collectionAgreementLogList,
    addCollectionAgreement,
    collectionAgreement,
    multipleUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      rowObj: {},
      imgList: [],
      vehicleNature: "",
      vehicleTypeOptions: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportJoinedTeamList", //导出接口
        name: "我的车队"
      },
      isOneDriver: false,
      message: "",
      loading: false,
      collectionAgreementLogListFlag: false,
      addCollectionFlag: false,
      collectionAgreementFlag: false,
      tableData: [],
      copy: false,
      listQuery: {
        bankPersonName: "",
        bankAccount: "",
        partyCode: "",
        collection: "",
        linkMan: "",
        name: "",
        phone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.listQuery.partyCode = this.$route.query.partyCode;
    const driver = this.$store.getters.driver;
    if (driver && driver.driverType == 0) {
      this.isOneDriver = true;
    }
    // this.findList()
  },
  methods: {
    uploadVehicleAgreementApi() {
      uploadVehicleAgreement({
        code: this.rowObj.code,
        vehicleNature: this.vehicleNature,
        urls: [...this.imgList]
      }).then(response => {
        this.$message({ message: "上传成功", type: "success" });
        this.findList();
        this.collectionAgreementFlag = false;
      });
    },
    handleImgSuccess(url) {
      console.log("===================", url);
    },
    VehicleTypeApi() {
      return VehicleType({ type: "vehicleNature" }).then(response => {
        this.vehicleTypeOptions = response.data.records;
      });
    },
    hideCollectionAgreementLogListModel() {
      this.collectionAgreementLogListFlag = false;
    },
    showCollectionAgreementLogListModel(code) {
      this.collectionAgreementLogListFlag = true;
      this.$refs.collectionAgreementLogListRef.init(code);
    },
    hideCollectionAgreementModel() {
      this.collectionAgreementFlag = false;
    },
    showCollectionAgreementModel(row) {
      this.rowObj = row;
      // if(row.agreementUrls && row.agreementUrls.length){
      this.imgList = row.agreementUrls || [];
      // }
      this.vehicleNature = row.vehicleNature + "";
      // vehicleNature：2   、agreementUrls
      this.collectionAgreementFlag = true;
      /*return;
      if(!bankAccount){
        this.$message.error("请提醒车队长提前维护银行卡信息！");
      }else{
        this.collectionAgreementFlag = true;
        this.$refs.collectionAgreementRef.findList(code);
      }*/
    },
    hideAddCollectionModel() {
      this.findList();
      this.addCollectionFlag = false;
    },
    showAddCollectionModel() {
      this.addCollectionFlag = true;
      this.$refs.addCollectionAgreementRef.init(this.listQuery.partyCode);
    },
    findList() {
      this.loading = true;
      return this.VehicleTypeApi().then(() => {
        return request({
          url: "/ntocc-basic-api/driver/vehicleList",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
        });
      });
    },
    // 退出车队
    outTeam(partyCode) {
      this.$confirm("确认退出吗？").then(_ => {
        request({
          url: "/ntocc-tms-api/acceptVehicle/exitTeam",
          method: "post",
          params: { teamCode: partyCode }
        }).then(response => {
          this.$message({ message: "退出成功", type: "success" });
          this.findList();
        });
      });
    }
  }
};
</script>

<style>
.vehicle-agreement-form {
  padding: 20px;
}

.vehicle-agreement-form .form-section {
  margin-bottom: 24px;
}

.vehicle-agreement-form .form-section h3 {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 12px;
}

.vehicle-agreement-form .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.vehicle-agreement-form .el-radio {
  font-size: 14px;
  color: #606266;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #ebf0f5;
  margin-top: 10px;
  text-align: right;
}
</style>
